import {
  Component,
  OnInit,
  Inject,
  Injector,
  HostListener,
  ElementRef,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { UserLoginInfoDto } from 'openapi/model/userLoginInfoDto';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT, PlatformLocation } from '@angular/common';
import { AccountService } from '@app/_services';
import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '../../app-component.base';
import { Location } from '@angular/common';
import { AccountService as UserService, ConfigurationService, TokenAuthService } from 'openapi';
import { CookieService } from 'ngx-cookie-service';
import { SharedDataService } from '@app/_helpers/shareddata.service';
import { NavController, Platform } from '@ionic/angular';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Globals } from '@app/globals';
import { SSOAuthService } from '@app/_services/sso.service';
import { StringUtils } from '@shared/utils/StringUtils';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent extends AppComponentBase implements OnInit {
  
  user: UserLoginInfoDto;
  isCollapsed: boolean = true;
  draweropen: boolean = false;
  collapsed: boolean = false;
  tenantId: number = 0;
  pageUrl: any = '';
  showbackbutton: boolean = false;
  showPageName: any = '';
  isMobile: boolean = false;

  @ViewChild('toggleButton') toggleButton: ElementRef;
  @ViewChild('leftmenu') leftmenu: ElementRef;

  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
    this.draweropen = !this.draweropen;

    this.renderer.listen('window', 'click', (e: Event) => {
      /**
       * Only run when toggleButton is not clicked
       * If we don't check this, all clicks (even on the toggle button) gets into this
       * section which in the result we might never see the menu open!
       * And the menu itself is checked here, and it's where we check just outside of
       * the menu and button the condition abbove must close the menu
       */
      if (e.target == this.leftmenu.nativeElement) {
        this.collapsed = false;
        this.draweropen = false;
      }
    });
  }

  constructor(
    injector: Injector,
    private renderer: Renderer2,
    private _location: Location,
    @Inject(DOCUMENT) private _document: Document,
    private accountService: AccountService,
    private _activateRoute: ActivatedRoute,
    private _router: Router,
    private userservice: UserService,
    private _cookieService: CookieService,
    public sharedDataService: SharedDataService,
    private platform: Platform,
    private navCtrl: NavController,
    private location: PlatformLocation,
    private deviceService: DeviceDetectorService,
    private nav: NavController,
    private appconfiguration:ConfigurationService,
    private tokenService:TokenAuthService,
    private ssoAuthService: SSOAuthService
  ) {
    super(injector);
    this.tenantId = abp.session.tenantId;
    _router.events.subscribe((val) => {
      if (_location.path() != '') {
        this.pageUrl = _location.path();
      }
      // console.log(this.pageUrl == '/credit-union');
      // if (this.pageUrl == '/credit-union' || this.pageUrl.indexOf('/credit-union/') >= 0) {
      //   this.showbackbutton = true;
      // } else {
      //   this.showbackbutton = false;
      // }

      if (
        this.pageUrl == '/credit-union' ||
        this.pageUrl.indexOf('/credit-union/') >= 0
      ) {
        this.showbackbutton = true;
        this.showPageName = ''; //In this case page name would be module name
      } else if (this.pageUrl.indexOf('/credit-union/addContribution') >= 0) {
        this.showbackbutton = true;
        this.showPageName = 'AddContribution';
      } else if (this.pageUrl.indexOf('/credit-union/common/payment-status') >= 0) {
        this.showbackbutton = false;
        this.showPageName = 'PaymentStatus';
      } else if (this.pageUrl.indexOf('/credit-union/yourloans') >= 0) {
        this.showbackbutton = true;
        this.showPageName = 'YourLoans';
      } else if (this.pageUrl.indexOf('/credit-union/apply-loan') >= 0) {
        this.showPageName = 'ApplyForLoan';
      } else if (this.pageUrl == '/more/language') {
        console.log('language');
        if(StringUtils.isMobilePlatform(this.platform)){
          this.showbackbutton = true;
          this.showPageName = ''; //In this case page name would be module name
        }
      
      } else if (this.pageUrl == '/more/contactus') {
        console.log('contactus');
        if(StringUtils.isMobilePlatform(this.platform)){
          this.showbackbutton = true;
          this.showPageName = ''; //In this case page name would be module name
        }
      } else if (this.pageUrl == '/more/bank-details/list') {
        console.log('bank details');
        if(StringUtils.isMobilePlatform(this.platform)){
          this.showbackbutton = true;
          this.showPageName = ''; //In this case page name would be module name
        }
      } else if (this.pageUrl == '/more/bank-details/create') {
        console.log('bank details create');
        if(StringUtils.isMobilePlatform(this.platform)){
          this.showbackbutton = true;
          this.showPageName = ''; //In this case page name would be module name
        }
      } else if (this.pageUrl.includes('/more/bank-details/edit')) {
        console.log('bank details edit');
        if(StringUtils.isMobilePlatform(this.platform)){
          this.showbackbutton = true;
          this.showPageName = ''; //In this case page name would be module name
        }
      } else if (this.pageUrl == '/more/setlocation') {
        console.log('setlocation');
        if(StringUtils.isMobilePlatform(this.platform)){
          this.showbackbutton = true;
          this.showPageName = ''; //In this case page name would be module name
        }
      } else if (this.pageUrl == '/more/documents') {
        console.log('upload documents');
        if(StringUtils.isMobilePlatform(this.platform)){
          this.showbackbutton = true;
          this.showPageName = ''; //In this case page name would be module name
        }
      } else if (this.pageUrl == '/more/mno-details/list-mno') {
        console.log('mno details list');
        if(StringUtils.isMobilePlatform(this.platform)){
          this.showbackbutton = true;
          this.showPageName = ''; //In this case page name would be module name
        }
      } else if (this.pageUrl == '/more/mno-details/create-mno') {
        console.log('mno details create');
        if(StringUtils.isMobilePlatform(this.platform)){
          this.showbackbutton = true;
          this.showPageName = ''; //In this case page name would be module name
        }
      }  else if (this.pageUrl.includes('/more/mno-details/edit')) {
        console.log('bank details edit');
        if(StringUtils.isMobilePlatform(this.platform)){
          this.showbackbutton = true;
          this.showPageName = ''; //In this case page name would be module name
        }
      }
      
      else {
        this.showbackbutton = false;
        this.showPageName = '';
      }
    });
  }

  ngOnInit(): void {
    this.user = this.accountService.userLoggedIn;

    this.appconfiguration.apiConfigurationDefaultcurrencyGet().subscribe(res=>{
      AppConsts.currency = res;
      AppConsts.currencySign = res;
    });
    
    if(StringUtils.isMobilePlatform(this.platform)){
      this.isMobile = true;
    }
  }

  // @HostListener('window:unload', ['$event'])
  // unloadHandler(event) {
  //     abp.ui.setBusy();
  //     this.userservice.apiAccountLogoutPost().subscribe(res => {
  //         this.accountService.logout(true);
  //     });
  // }

  // @HostListener('window:beforeunload', ['$event'])
  // onUnloadHandler(event) {
  //     if(navigator.userAgent.indexOf("Chrome") == -1 ){
  //     abp.ui.setBusy();
  //     this.userservice.apiAccountLogoutPost().subscribe(res => {
  //         this.accountService.logout(true);
  //     });
  //     }
  // }
  
  logout() {
    abp.ui.setBusy();
    this.tokenService.apiAccountLogoutPost(Globals.isMobile).subscribe((res) => {
      // this.accountService.logout(true);
      this.ssoAuthService.logout();
    });
  }

  hasTenantId() {
    return this.tenantId > 0;
  }

  back() {
    if (this.showbackbutton) {
      if(StringUtils.isMobilePlatform(this.platform)){
    
        if (this._location.path() != '') {
          this.pageUrl = this._location.path();
          // if (this.pageUrl == '/credit-union' || this.pageUrl.indexOf('/credit-union/') >= 0) {
          //    this._router.navigate(['./credit-union-list']);
          // } else {
          //   this._location.back();
          // }
          console.log('pageUrl' + this.pageUrl);


          if (this.pageUrl == '/credit-union') {
            if(StringUtils.isMobilePlatform(this.platform) && this.platform.is('android')){
              window.localStorage.setItem('clearHistory', '1');
              if (window.localStorage.getItem("backPressPaymentReceipt") != null && window.localStorage.getItem("backPressPaymentReceipt") == '1') {
                window.localStorage.removeItem('backPressPaymentReceipt');
              }
             }
            this._router.navigate(['./credit-union-list']);
          }
          else if (this.pageUrl == '/credit-union/addContribution' || 
          this.pageUrl == '/credit-union/apply-loan' ||
          this.pageUrl == '/credit-union/mycontributions'
          ){
            this._location.back();
          }
          else if (this.pageUrl == '/credit-union/yourloans'
          ){
            // this._location.back();
            if (window.localStorage.getItem("backAfterApplyLoan") != null && window.localStorage.getItem("backAfterApplyLoan") == '1') {
              window.localStorage.removeItem('backAfterApplyLoan');
            }

            // if(this.platform.is("android")) {
            //   this.location.back();
            // } 
            this._router.navigate(['./credit-union']);
          }
          else if (
            this.pageUrl == '/credit-union/payment-receipt' 
          ) {
            if(StringUtils.isMobilePlatform(this.platform) && this.platform.is('android')){
              // window.localStorage.setItem('clearHistory', '1');
              window.localStorage.setItem('backPressPaymentReceipt', '1');
              // navigator['app'].clearHistory();
            }
            this._router.navigate(['./credit-union'], { replaceUrl: true });
          } else if (
            this.pageUrl == '/credit-union/payment-status'
          ) {
            this._router.navigate(['./credit-union/common/select-paymentmode']);
          } 

          else if (this.pageUrl === '/more/bank-details/list'){
            // alert("test");
            console.log('current page bank details list');
            if (window.localStorage.getItem("backAfterAddBankDetial") != null && window.localStorage.getItem("backAfterAddBankDetial") == '1') {
              window.localStorage.removeItem('backAfterAddBankDetial');
              // this.location.back();
              this._router.navigate(['./more'], { replaceUrl: true });
            } else {
              this.location.back();
              // this._router.navigate(['./more']);
            }
           
          }
          else if (this.pageUrl === '/more/mno-details/list-mno'){
            // alert("test");
            console.log('current page mno details list');
            if (window.localStorage.getItem("backAfterAddMnoDetial") != null && window.localStorage.getItem("backAfterAddMnoDetial") == '1') {
              window.localStorage.removeItem('backAfterAddMnoDetial');
              // this.location.back();
              this._router.navigate(['./more'], { replaceUrl: true });
            } else {
              this.location.back();
              // this._router.navigate(['./more']);
            }
           
          }
          //  else if (
          //   this.pageUrl == '/credit-union/common/select-paymentmode'
          // ) {
          //   this._router.navigate(['./credit-union/addContribution']);
          // } 
          //  else if (this.pageUrl == '/credit-union-list' || this.pageUrl == '/profile' || this.pageUrl == '/more') {
          //   // this._location.back();
          // }
          else {
     
            this._location.back();
          }
        } else {
        
          this._location.back();
        }
      } else {
        
        this._location.back();
      }
    }
  }
}
